import React, { useCallback, useState } from 'react';

import { Container, Content } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  places: any;
  comp: string;
  handleSubmitEnd: any;
}

const ModalPerfilEndConfirm: React.FC<ModalPARAMS> = ({
  id = 'modalPerfilEndConfirm',
  onClose = () => {},
  isVisible,
  places,
  comp,
  handleSubmitEnd,
}) => {
  /* const handleOutSideClick = useCallback(
    e => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  ); */
  const handleOnClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const handleSubmit = useCallback(async () => {
    handleOnClose();
    handleSubmitEnd();
  }, [handleSubmitEnd, handleOnClose]);

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalPerfilEndConfirm">
      <Content className={`${visible ? 'active' : ''}`}>
        <h1>Endereço da loja</h1>

        <div className="div-data">
          {places && (
            <>
              {/* RUA, NÚMERO */}
              <h2>
                {places![0].address_components[0]?.types[0] === 'route'
                  ? places![0].address_components[0]?.short_name
                  : places![0].address_components[1]?.short_name}
                {places![0].address_components[0]?.types[0] ===
                  'street_number' &&
                  `, ${places![0].address_components[0]?.short_name}`}
              </h2>

              {/* BAIRRO */}
              <h2>
                {places![0].address_components[1]?.types[0] ===
                'sublocality_level_1'
                  ? places![0].address_components[1]?.short_name
                  : places![0].address_components[2]?.short_name}
              </h2>

              {/* COMPLEMENTO */}
              <h2 style={{ color: '#607D8B' }}>{comp}</h2>

              {/* CEP */}
              <h2>
                {places![0].address_components[5]?.types[0] === 'postal_code'
                  ? `CEP - ${places![0].address_components[5]?.short_name}`
                  : `CEP - ${places![0].address_components[6]?.short_name}`}
              </h2>

              {/* CIDADE, ESTADO */}
              <h2>
                {places![0].address_components[2]?.types[0] ===
                'administrative_area_level_2'
                  ? places![0].address_components[2]?.short_name
                  : places![0].address_components[3]?.short_name}

                {places![0].address_components[3]?.types[0] ===
                'administrative_area_level_1'
                  ? `, ${places![0].address_components[3]?.short_name}`
                  : `, ${places![0].address_components[4]?.short_name}`}
              </h2>
            </>
          )}
        </div>

        <button onClick={handleSubmit} className="btn-confirm">
          Confirmar
        </button>

        <button onClick={handleOnClose}>Cancelar</button>
      </Content>
    </Container>
  );
};

export default ModalPerfilEndConfirm;
